module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("CAST OF CHARACTERS")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Opener-Paragraph"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Dane Thorson:")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" He wanted to spend a short vacation on Khatka, not the rest of his life.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Line-Break"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Medic Tau: ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Was he physician or magician—or a little bit of both?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Line-Break"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Chief Ranger Asaki:")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" Tracking the forests had taught him that mad animals—whether real or imaginary—were to be feared.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Line-Break"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Captain Jellico:")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" Would his knowledge of alien life-forms help him in his fight against alien ghosts?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Line-Break"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Nymani:")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(" Not even this pilot’s most scientific skill could overcome a voodoo charm’s ground-drag.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Line-Break"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Lumbrilo: ")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("On his own planet he was a witch doctor; on Earth he’d have been a master politician.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53907217","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Voodoo_Planet-1.vue
// module id = 69
// module chunks = 0